'use client';

import SafeImage from '@ui/SafeImage';
import Toggle from '@ui/Toggle';
import { prefix } from '@util/imagePrefix';
import { getMakeLogo } from 'app/create-listing/_components/BikeFitment';
import { Bike } from 'models/shared';
import { useState } from 'react';

type EditGarageFormProps = {
  bikes: Bike[];
  onAddBikeClick: () => void;
  onSyncSelectedBikes: (bikes: Bike[]) => void;
  previousSelectedBikes: Bike[];
};

export default function EditGarageForm({
  bikes,
  onAddBikeClick,
  onSyncSelectedBikes,
  previousSelectedBikes,
}: EditGarageFormProps) {
  const [selectedBikes, setSelectedBikes] = useState<Bike[]>(
    previousSelectedBikes
  );

  return (
    <div className="relative flex h-full w-full flex-col">
      <div className="relative max-h-[55rem] flex-1 overflow-y-auto px-8 pb-[13rem] pt-8">
        {bikes.map((bike, index) => (
          <div
            className="mb-8 flex h-[5rem] w-full items-center justify-between"
            key={index}
          >
            <div className="flex items-center gap-x-16 pb-4">
              <div className="flex w-[10rem] items-center justify-center">
                <SafeImage
                  src={getMakeLogo(prefix, bike.make)}
                  alt={bike.make}
                  className="mt-4 h-[2rem] object-contain object-center"
                  fallback={
                    <div className="flex h-[6rem] items-center py-6 text-[1.6rem] font-bold uppercase">
                      {bike.make}
                    </div>
                  }
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <span className="text-[1.8rem] font-semibold text-black">
                  {bike.make}
                </span>

                <div className="flex items-center gap-x-1">
                  <span className="truncate text-[1.6rem] font-medium text-[#7F7F7F]">
                    {bike.year}
                  </span>

                  <span className="w-[18rem] truncate text-[1.6rem] font-medium text-[#7F7F7F]">
                    {bike.model}
                  </span>
                </div>
              </div>
            </div>

            <Toggle
              enabled={selectedBikes.includes(bike)}
              onChange={() => {
                if (selectedBikes.includes(bike)) {
                  setSelectedBikes(selectedBikes.filter((b) => b !== bike));
                } else {
                  setSelectedBikes([...selectedBikes, bike]);
                }
              }}
            />
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 left-0 flex w-full justify-between gap-8 border-t border-zinc-200 bg-white p-8">
        <button
          type="button"
          className="flex h-[5rem] w-full items-center justify-center rounded-[1.5rem] border border-zinc-700 bg-transparent text-[1.8rem] font-medium text-zinc-900 transition-colors duration-150 ease-out hover:border-black hover:text-black"
          onClick={onAddBikeClick}
        >
          Add Vehicle
        </button>

        <button
          type="button"
          className="flex h-[5rem] w-full items-center justify-center rounded-[1.5rem] bg-brand-secondary text-[1.8rem] font-medium text-white transition-colors duration-150 ease-out hover:bg-brand-secondary-darker"
          onClick={() => onSyncSelectedBikes(selectedBikes)}
        >
          Save My Garage
        </button>
      </div>
    </div>
  );
}
